module.exports = __webpack_public_path__ + "static/img/xcx.30af07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/xcx.png
// module id = jYih
// module chunks = 0